/**
 * Purpose:
 *   Tailwind CSS class constants for ToastViewport component.
 */

export const toastViewportStyles = {
  container: `
    fixed z-[1000] top-4 md:left-auto md:w-[380px]
    space-y-2 pointer-events-none
  `,

  itemWrapper: `
    pointer-events-auto w-screen flex justify-center
  `,
};

